export interface SettingFugitiveStatus {
  status: string;
  remark: string;
  _id: string;
}

export interface FilterColumns {
  key: string;
  filter: (number | string)[];
}

export interface SettingEqTypeFugitive {
  equipmentType: string;
  equipmentTypeList: string[];
  symbol: string;
  _id: string;
}

export interface SettingUncheckFugitive {
  code: number | null;
  uncheck: string;
  reasonForException: string;
  _id: string;
}

export interface SettingSTDControlFugitive {
  emission: string;
  std: string;
  _id: string;
}

export interface Emission {
  series: string;
  bz: number;
  bd: number;
  edc: number;
  vcm: number;
}

export interface AreaSeriesDto {
  area: string;
  series: Emission[];
}

export interface AreaSeriesGroupCompany {
  companyId: string;
  areas: AreaSeriesDto[];
}

export interface AreaSeries {
  areaSeries: AreaSeriesGroupCompany[];
}

export interface SettingComBySeries {
  _id?: string;
  companyId: string;
  areas: AreaSeriesDto[];
}

export interface DataTableComBySeries {
  _id: string;
  companyId: string;
  area: string;
  series: string;
  bz: number;
  bd: number;
  edc: number;
  vcm: number;
}

export interface Filter {
  text: string;
  value: string;
}

export const initStatusFugitive = {
  status: "",
  remark: "",
  _id: "",
};

export const initEqTypeFugitive = {
  equipmentType: "",
  equipmentTypeList: [],
  symbol: "",
  _id: "",
};

export const initUncheckFugitive = {
  code: null,
  uncheck: "",
  reasonForException: "",
  _id: "",
};

export const initStdControlFugitive = {
  emission: "",
  std: "",
  _id: "",
};

export const initComBySeriesFugitive = {
  _id: "",
  areaSeries: [
    {
      companyId: "",
      areas: [
        {
          area: "",
          series: [
            {
              series: "",
              bz: null,
              bd: null,
              edc: null,
              vcm: null,
            },
          ],
        },
      ],
    },
  ],
};

export interface Dropdown {
  key?: string;
  label: string;
  value: string | number;
  disabled?: boolean;
}
